export {
  trackIdentity,
  trackGroup,
  trackEvent,
  trackPage,
} from './dataTracking';
